import React from 'react'
import { InputText } from 'primereact/inputtext'

export default function Redemption({ form, handleChange }) {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      {/* single-line header */}
      <h4 className="text-xl font-semibold mb-4 whitespace-nowrap">Redemptions</h4>
      {/* two inputs side by side */}
      <div className="grid grid-cols-2 gap-4">
        <div className="flex flex-col">
          <label htmlFor="perUserLimit" className="mb-2 font-medium text-gray-700">
            Per User Limit
          </label>
          <InputText
            id="perUserLimit"
            value={form.redeemptions?.perUserLimit || ''}
            onChange={e => handleChange('redeemptions.perUserLimit', e.target.value)}
            placeholder="Enter per-user limit"
           className="w-full border border-gray-300 rounded p-2"

          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="totalLimit" className="mb-2 font-medium text-gray-700">
            Total Limit
          </label>
          <InputText
            id="totalLimit"
            value={form.redeemptions?.totalLimit || ''}
            onChange={e => handleChange('redeemptions.totalLimit', e.target.value)}
            placeholder="Enter total limit"
           className="w-full border border-gray-300 rounded p-2"

          />
        </div>
      </div>
    </div>
  )
}
